import { render, staticRenderFns } from "./site.vue?vue&type=template&id=5246d846&scoped=true&"
import script from "./site.vue?vue&type=script&lang=js&"
export * from "./site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5246d846",
  null
  
)

export default component.exports